import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { links } from '[theme-lib]/links';

import { reportCheckoutButtonClicked } from '../actions/checkoutButton';
import { priceFormat } from 'apps/products/utils/priceFormat';
import shopControlsVisibilities from 'apps/header/utils/shopControlsVisibilities';

import Tooltip from 'widgets/Tooltip/Tooltip';

const CheckoutButton = ({ basket, className, router, shopControlsVisibility }) => {
  const onCheckoutButtonClick = () => {
    const redirect = () => router.push({
      pathname: links.CHECKOUT,
    });

    reportCheckoutButtonClicked('DESKTOP_HEADER', redirect);
  };

  return (shopControlsVisibility === shopControlsVisibilities.SLOT_BOOKING_AND_CHECKOUT) && (
    basket.checkoutAllowed
      ? (
        <button
          className={classNames('button', 'continue', className)}
          onClick={onCheckoutButtonClick}
        >
          Checkout
        </button>
      ) : (
        <Tooltip
          className="gn-tooltip__whiteTheme"
          label={(
            <button
              className={classNames('button', 'continue', 'disabled', className)}
            >
              Checkout
            </button>)}
        >
          <h3>Below min. order</h3>
          <p>
            To check out, your trolley needs to be {
              priceFormat({ value: basket.minimumOrderValue, zeroAfterPound: false, inPound: true })
            } for delivery
          </p>
        </Tooltip>
      )
  );
};

CheckoutButton.propTypes = {
  basket: PropTypes.object.isRequired,
  className: PropTypes.string,
  shopControlsVisibility: PropTypes.string.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

CheckoutButton.defaultProps = {
  className: '',
};

export default CheckoutButton;
